import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "col-span-12" }
const _hoisted_2 = { class: "p-6 text-sm font-normal text-gray-900" }
const _hoisted_3 = { class: "text-sm font-normal text-gray-900" }
const _hoisted_4 = { class: "text-sm font-normal text-gray-900" }
const _hoisted_5 = { class: "flex justify-center p-6 space-x-2" }
const _hoisted_6 = { class: "flex justify-end col-span-12" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "Add New", -1)

import IntakeLayout from '../../Component/IntakeLayout.vue';
import ViewButton from "@/components/buttons/ViewButton.vue";
import DeleteButton from "@/components/buttons/DeleteButton.vue";
import DataTable from "@/components/partials/DataTable.vue";
import ContentModal from "../../Component/ContentModal.vue";
import { ref, onMounted,computed } from 'vue'; 
import { PlusIcon } from "@heroicons/vue/24/solid"; 
import SuccessModal from "@/components/modals/SuccessModal.vue";
import TextInput from "@/components/inputs/TextInput.vue";
import ButtonComponent from "@/components/buttons/ButtonComponent.vue";
import EmailService from '@/classes/Cases/IntakeForm/EmailService';
import { EmailIndex } from '@/interfaces/Cases/IntakeForm/Email';
import { useRoute } from "vue-router";
import pickBy from "lodash/pickBy";
import PageLoader from "@/components/loaders/PageLoader.vue"
import ConfirmationModal from "@/components/modals/ConfirmationModal.vue";
import { errorResponse } from "@/helpers/errorMessage"; 
import { onIonViewWillEnter } from '@ionic/vue'; 

/******************************* For Offline Imports************************************ */
  import { useNetworkStore } from "@/store/network";
 import Rules from "@/classes/Cases/Intake/EmailAddresses/Validation/Rules";
 import ErrorValidation from "@/views/interventions/Components/Classess/ErrorValidation";
 import useVuelidate from "@vuelidate/core"; 
 import  EmailForm from "@/classes/Cases/Intake/EmailAddresses/Formatter/EmailForm";
 import EmailAddressService from "@/classes/Cases/Intake/EmailAddresses/EmailAddressService";
 import EmailOfflineProcessor from '@/classes/Cases/Intake/EmailAddresses/Processor/OfflineProcessor';
 import OnlineSynching from '@/classes/Synching/OnlineSynching';

 
export default /*#__PURE__*/_defineComponent({
  __name: 'IndexPage',
  setup(__props) {

const { createRules } = Rules;
 const networkStore = useNetworkStore();
 const isNetworkAvailable = computed(() => networkStore.isNetworkAvailable); 
 /*************************************************************************************** */
 
const route = useRoute();
const showSuccess = ref<boolean>(false);
const showContent = ref<boolean>(false);
const items = ref<EmailIndex[]>([]);
const patientId = ref<number | null>(route.params.patient);
const caseId = ref<number | null>(route.params.case);
const loading = ref<boolean>(false);
const isUpdate = ref<boolean>(false)
const showConfirmation = ref<boolean>(false)
const selectedItemId = ref<number | null>(null)
const showDeleteSuccess = ref<boolean>(false)
const errors = ref<object | null>(null);
const patient = ref<string>(''); 
const isIonWillEnter = ref<boolean>(false);
const onlineSync = new OnlineSynching();

const headers = [
	{ text: 'Email Address' },
	{ text: 'Label' },
	{ text: 'Date Updated' },
]

const form = ref(EmailForm.createForm() )

const clearForm = () => { EmailForm.createForm() }

const showCreateModal =() => {
	form.value = EmailForm.createForm();
	isUpdate.value = false;
	showContent.value = true;
	errors.value = null;
}
const showModal = (item:any) => { 
	form.value = EmailForm.updateForm(item);
	selectedItemId.value = item.id
	showContent.value = true
	isUpdate.value = true
    errors.value = null;
}

const showDeleteModal = (item:any) => {
	form.value = EmailForm.deleteForm(item);
	showConfirmation.value = true
	selectedItemId.value = item.id
	clearForm();
}
 /**
 * Validate the form using Vuelidator
 */
 const validateForm = () =>{
	
	const vuelidate = useVuelidate(createRules({...form.value}), form.value)
	const result = vuelidate.value.$validate();
 
	result.then((res) => {
		if(res) { 
			addNew()
		} else {
			errors.value = ErrorValidation.getErrors(vuelidate.value)
            errorResponse(errors.value);
		}
	})
}
const addNew = async () => {
	loading.value = true;
    errors.value = null; 
 
	if(isUpdate.value){
		await EmailAddressService.update(patientId.value, caseId.value, selectedItemId.value, isNetworkAvailable.value, form.value)
			.then((response: object) => {
				showSuccess.value = true;
				setTimeout(() => {
					showSuccess.value = false;
				}, 2000)
				
				loading.value = false;
				showContent.value = false;
			
				getData()
			})
			.catch((error: object) => {
				loading.value = false;
				errors.value = errorResponse(error.response?.data?.errors);
			});
	}else{
		await EmailAddressService.store(patientId.value, caseId.value, isNetworkAvailable.value, form.value)
			.then((response: object) => {
				showSuccess.value = true;
				setTimeout(() => {
					showSuccess.value = false;
				}, 2000)
				
				loading.value = false;
				showContent.value = false;
			
				getData()
			})
			.catch((error: object) => {
				loading.value = false;
				errors.value = errorResponse(error.response?.data?.errors);
			});
	}
}



const getData = async () => { 
	loading.value = true;
	if (caseId.value) {
		await EmailAddressService.index(
			patientId.value,
			caseId.value,
			isNetworkAvailable.value,
			pickBy({ ...{ rows: 10 } }),
		)
			.then(async (response: object) => {
				items.value = response.data.items;
				console.log(items.value);
				patient.value = response.data.patient; 
                if (isNetworkAvailable.value) {
                    await syncToOffline();
                }
				loading.value = false;
			})
			.catch((error: object) => {
				errors.value = errorResponse(error.response?.data?.errors);
				loading.value = false;
			});
	}
};

const syncToOffline = async () => {
    for (const index in items.value.data) {
        const item = items.value.data[index];
        await EmailOfflineProcessor.syncToOffline(caseId.value, item);
    }
}

const deleteItem = async () => {
	loading.value = true; 
	await EmailAddressService.delete(
		patientId.value,
		caseId.value,
		selectedItemId.value,
		isNetworkAvailable.value,
		form.value,
	)
		.then(async () => {
            if (isNetworkAvailable.value) {
                await EmailOfflineProcessor.delete(selectedItemId.value, caseId.value, true);
            }
			loading.value = false;
			showDeleteSuccess.value = true;
			setTimeout(() => {
				showDeleteSuccess.value = false;
			}, 2000)
			showConfirmation.value = false;
			getData()
		})
		.catch((error: object) => {
			errors.value = errorResponse(error.response?.data?.errors);
			loading.value = false;
		});
  
};


onIonViewWillEnter(async () => {
    if (isIonWillEnter.value) {
        await getData();
        await onlineSync.checkDrafts();
    }
});

onMounted(async () => {
    await getData();
    await onlineSync.checkDrafts();
    isIonWillEnter.value = true;
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IntakeLayout, { patient: patient.value }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(DataTable, {
          headers: headers,
          "no-action": false,
          count: items.value?.data?.length,
          dataTableClass: "border-t-0 border-x-0 "
        }, {
          body: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value.data, (item) => {
              return (_openBlock(), _createElementBlock("tr", { key: item }, [
                _createElementVNode("td", _hoisted_2, _toDisplayString(item.email), 1),
                _createElementVNode("td", _hoisted_3, _toDisplayString(item.label), 1),
                _createElementVNode("td", _hoisted_4, _toDisplayString(item.updated_at_formatted), 1),
                _createElementVNode("td", _hoisted_5, [
                  _createVNode(ViewButton, {
                    isEyeIcon: false,
                    onClick: ($event: any) => (showModal(item)),
                    class: "shrink-0"
                  }, null, 8, ["onClick"]),
                  _createVNode(DeleteButton, {
                    onClick: ($event: any) => (showDeleteModal(item)),
                    class: "shrink-0"
                  }, null, 8, ["onClick"])
                ])
              ]))
            }), 128))
          ]),
          _: 1
        }, 8, ["count"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(ButtonComponent, {
          customClass: "primary sm:w-auto w-full",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (showCreateModal()))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(PlusIcon), { class: "w-3.5 h-3.5" }),
            _hoisted_7
          ]),
          _: 1
        })
      ]),
      _createVNode(SuccessModal, {
        noBtn: "",
        show: showSuccess.value,
        "action-text": "Close",
        title: "Record Save",
        content: "Intake has been updated",
        onClose: _cache[1] || (_cache[1] = ($event: any) => (showSuccess.value = false))
      }, null, 8, ["show"]),
      _createVNode(ConfirmationModal, {
        typeTwo: true,
        show: showConfirmation.value,
        onCancel: _cache[2] || (_cache[2] = ($event: any) => (showConfirmation.value = false)),
        onConfirm: _cache[3] || (_cache[3] = ($event: any) => (deleteItem())),
        "cancel-text": "Cancel",
        "action-text": "Confirm",
        title: "Delete Record?",
        content: "Are you sure you wish to delete this record?"
      }, null, 8, ["show"]),
      _createVNode(SuccessModal, {
        noBtn: "",
        show: showDeleteSuccess.value,
        "action-text": "Close",
        title: "Record Deleted!",
        content: "Selected record has been successfully deleted.",
        onClose: _cache[4] || (_cache[4] = ($event: any) => (showDeleteSuccess.value = false))
      }, null, 8, ["show"]),
      _createVNode(ContentModal, {
        show: showContent.value,
        title: "Add Email Address"
      }, {
        button: _withCtx(() => [
          _createVNode(ButtonComponent, {
            btnWidth: "quinary",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (showContent.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Cancel ")
            ]),
            _: 1
          }),
          _createVNode(ButtonComponent, {
            customClass: "primary",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (validateForm()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Save Changes ")
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(TextInput, {
              label: "Label",
              placeholder: "Label",
              name: "label",
              id: "label",
              modelValue: form.value.label,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.label) = $event)),
              error: errors.value?.label
            }, null, 8, ["modelValue", "error"])
          ]),
          _createElementVNode("div", null, [
            _createVNode(TextInput, {
              type: "email",
              label: "Email Address",
              placeholder: "sample@gmail.com",
              name: "email_address",
              id: "email_address",
              modelValue: form.value.email,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.email) = $event)),
              error: errors.value?.email
            }, null, 8, ["modelValue", "error"])
          ])
        ]),
        _: 1
      }, 8, ["show"]),
      _createVNode(PageLoader, { show: loading.value }, null, 8, ["show"])
    ]),
    _: 1
  }, 8, ["patient"]))
}
}

})